var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11467_239166",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11467_239166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17C8.28333 17 8.521 16.904 8.713 16.712C8.90433 16.5207 9 16.2833 9 16V11C9 10.7167 8.90433 10.479 8.713 10.287C8.521 10.0957 8.28333 10 8 10C7.71667 10 7.479 10.0957 7.287 10.287C7.09567 10.479 7 10.7167 7 11V16C7 16.2833 7.09567 16.5207 7.287 16.712C7.479 16.904 7.71667 17 8 17ZM12 17C12.2833 17 12.521 16.904 12.713 16.712C12.9043 16.5207 13 16.2833 13 16V8C13 7.71667 12.9043 7.479 12.713 7.287C12.521 7.09567 12.2833 7 12 7C11.7167 7 11.4793 7.09567 11.288 7.287C11.096 7.479 11 7.71667 11 8V16C11 16.2833 11.096 16.5207 11.288 16.712C11.4793 16.904 11.7167 17 12 17ZM16 17C16.2833 17 16.5207 16.904 16.712 16.712C16.904 16.5207 17 16.2833 17 16V14C17 13.7167 16.904 13.479 16.712 13.287C16.5207 13.0957 16.2833 13 16 13C15.7167 13 15.4793 13.0957 15.288 13.287C15.096 13.479 15 13.7167 15 14V16C15 16.2833 15.096 16.5207 15.288 16.712C15.4793 16.904 15.7167 17 16 17ZM5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM5 19H19V5H5V19Z",
    fill: "#00B0CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.b65a47ab659d5df4da8b555ed6246fe8.svg";
export { ForwardRef as ReactComponent };